import React from 'react';
import Link from 'next/link';
import { MenuLinkProps } from './types';

export default function MenuLink({ href, className = '', target, rel, children }: MenuLinkProps) {
  return (
    <Link
      href={href}
      target={target}
      rel={rel}
      className={`text-primary-500 no-underline! hover:text-secondary-500 transition-colors duration-200 ${className}`.trim()}
    >
      {children}
    </Link>
  );
}
